import React from 'react';
import * as Utils from 'utils';

export default function CartOptionsPerHour({options}) {
  return (
    <>
      {options.length > 0 &&
        <div className="app-cart-options">
          <h6 className="app-cart-options-add-title">Additional Options (to be paid later)</h6>
          <div className="app-cart-option-list">
            {options.map((option, optionIndex) => {
              return (
                <div className="app-cart-option-item" key={optionIndex}>
                  <div className="app-cart-line">
                    <div className="app-cart-line-left">
                      <span className="app-cart-text-parameter-light">{Utils.replacer(option, 'priceLabel')}</span>
                    </div>
                    <div className="app-cart-line-right">
                      <span className="app-cart-text-value">{Utils.replacer(option, 'priceValueText')}</span>
                    </div>
                  </div>
                </div>
              )
            })}
          </div>
        </div>
      }
    </>
  )
}
